import {isModelId,type CodexNotification} from '@reados/contracts';
/** Only an accepted context for this exact Quick Chat can replace its model. */
export function acceptedQuickChatModel(threadId:string,events:CodexNotification[]):string|undefined {
 for(const event of [...events].reverse()){
  if(event.method!=='reados/quickChatContext')continue;
  const snapshot=event.params.snapshot;
  if(snapshot&&typeof snapshot==='object'&&'version' in snapshot&&(snapshot.version===1||snapshot.version===2)&&'threadId' in snapshot&&snapshot.threadId===threadId&&'model' in snapshot&&isModelId(snapshot.model))return snapshot.model;
 }
 return undefined;
}
export const quickChatModel=(value:unknown)=>isModelId(value)?value:'';
